import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:filter
 * @description
 * # filter
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('adminFilterController', ($ngRedux, $scope) => {
    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.init();

    $scope.$on('$destroy', function () {
      $scope.unsubscribe();
    });
  })
  .directive('adminFilters', () => {
    return {
      templateUrl: 'templates/v2/filters.html',
    };
  });
